export default __webpack_public_path__ + "static/media/9_temperatursturz.2aa6385b.png";